import { ProblemsTemplate, type ProblemsTemplateRow } from '../../templates';
import { DocumentSource, DocumentType } from '../types';
import type { DocumentEntry, DocumentKey } from '../types';
import { getProviderFacilityPdfEntry } from './pdfOverride';
import type { RawSourceMetadata } from './_shared';

type ProblemsDataKey = Extract<
  DocumentKey,
  { source: DocumentSource.MEDICAL_DATA; type: DocumentType.PROBLEMS }
>;

interface RawProblem extends ProblemsTemplateRow {
  resolutionDate?: string;
  sourceMetadata?: RawSourceMetadata;
  patientId?: string;
  problemCodes?: string[];
  categoryCodes?: string[];
  categoryCodeName?: string;
}

export interface ProblemsDataQueryData {
  problems: RawProblem[];
}

export const adaptProblemsData = (
  data: ProblemsDataQueryData,
  key: ProblemsDataKey,
): DocumentEntry | undefined => {
  const problems = data?.problems ?? [];
  if (problems.length === 0) return undefined;

  const pdf = getProviderFacilityPdfEntry(key.sourceType, problems, {
    title: key.name,
  });
  if (pdf) return pdf;

  return {
    kind: 'template',
    title: key.name,
    highlightAnchorId: `problem-${key.problemId}`,
    render: (ctx) => (
      <ProblemsTemplate
        problems={problems}
        patient={ctx?.patient}
        filename={ctx?.filename}
        generatedAt={new Date()}
        highlightProblemId={key.problemId}
      />
    ),
  };
};
